var rapm_slider = ( function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '#rapm-slider' ).find( '.owl-carousel' );

		_setup_slider();

		_first_active();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		var icons_dir = ScriptData.theme_uri + '/assets/icons';

		$carousel.owlCarousel( {
			items: 2,
			loop: true,
			dots: false,
			nav: true,
			autoHeight: true,
			navText: [
				'<img class="prev" src="' + icons_dir + '/arrow-left-grey.svg" />',
				'<img class="next" src="' + icons_dir + '/arrow-right-grey.svg" />'
			],
			responsive: {
				0 : { items : 1 },
				768 : { items : 2 }
			}
		} );

		$carousel.on( 'translated.owl.carousel' , _first_active );
	};

	// So that we can have a border only on the first active element
	var _first_active = function( e ) {
		var $stage = $( '#rapm-slider' ).find( '.owl-stage' );
		var $first_active = $stage.find( '.active:first' );
		var $prev_active = $stage.find( '.first-active' );

		if ( $prev_active.length > 0 ) {
			$prev_active.removeClass( 'first-active' );
		}

		$first_active.addClass( 'first-active' );
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '#rapm-slider' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = rapm_slider;